
import { defineComponent, computed, PropType, onMounted } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { object } from 'yup'
import { myValidationSchemaObj, validationMessage } from '@/views/validation'
import { useForm } from 'vee-validate'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'
import { YukashoukenUiItem } from '@/views/fuzoku-meisai/kaikei-kijun/data'
import NumberWithComma from '@/views/components/NumberWithComma.vue'

type InputForm = {
  itemName: string;
  amount: number;
}

const validationSchema = object({
  itemName: myValidationSchemaObj.maxString(20),
  amount: myValidationSchemaObj.requiredPositiveNum
})

export default defineComponent({
  components: {
    NumberWithComma,
    SettingPanel
  },
  props: {
    item: {
      type: Object as PropType<YukashoukenUiItem>,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    upItem: (item: YukashoukenUiItem) => true,
    downItem: (item: YukashoukenUiItem) => true,
    trashItem: (item: YukashoukenUiItem) => true,
    changeInput: (item: YukashoukenUiItem) => true
  },
  setup (props, { emit }) {
    const { errors, values, meta, validate } = useForm<InputForm>({
      validationSchema: validationSchema,
      initialValues: {
        itemName: props.item.item.itemName,
        amount: props.item.item.amount
      }
    })
    const headerName = computed(() => {
      if (!values.itemName) {
        return validationMessage.enterItem
      }
      return values.itemName
    })

    const onClickedUpItem = () => {
      emit('upItem', props.item)
    }

    const onClickedDownItem = () => {
      emit('downItem', props.item)
    }

    const onClickedTrashItem = () => {
      emit('trashItem', props.item)
    }

    const onChange = async () => {
      const item = props.item
      item.item.itemName = values.itemName
      item.item.amount = values.amount
      await validate()
      item.isValid = meta.value.valid
      emit('changeInput', item)
    }

    const onUpdateKmk = (panelName: string, item: ResponseSettingItem) => {
      const propItem: YukashoukenUiItem = props.item
      propItem.item.setting = item
      emit('changeInput', propItem)
    }

    onMounted(async () => {
      await validate()
      const item = props.item
      item.isValid = meta.value.valid
      emit('changeInput', item)
    })

    return {
      headerName,
      errors,
      values,
      onClickedUpItem,
      onClickedDownItem,
      onClickedTrashItem,
      onChange,
      onUpdateKmk
    }
  }
})
